import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Operation from './pages/Operation';
import AntiAgingHabits from './pages/AntiAgingHabits';
import Program from './pages/Program';
import ApplyPage from './pages/ApplyPage';
import AdminPage from './pages/AdminPage';
import AdminLoginPage from './pages/AdminLoginPage';
import ProtectedRoute from './routes/ProtectedRoute';

export default function App() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/admin-login';

  return (
    <>
      {!isLoginPage && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/operation" element={<Operation />} />
        <Route path="/anti-aging-habits" element={<AntiAgingHabits />} />
        <Route path="/program" element={<Program />} />
        <Route path="/apply" element={<ApplyPage />} />

        {/* 로그인 */}
        <Route path="/admin-login" element={<AdminLoginPage />} />

        {/* 보호 라우트 */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<h2>404 - 페이지가 없습니다</h2>} />
      </Routes>

      {!isLoginPage && <Footer />}
    </>
  );
}